// @ts-expect-error not typed
import SearchableCalleeList from 'calling-ui-library/callee-select/components/SearchableCalleeList';
// @ts-expect-error not typed

import CurrentSettingsInfoHelpDesk from './CurrentSettingsInfoHelpDesk';
import { isProviderSwitchingEnabled } from 'calling-internal-common/utils/isProviderSwitchingEnabled';
import { useMemo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallNotesButtonWrapper = ({
  children
}) => /*#__PURE__*/_jsx(View, {
  position: "sticky",
  insetBlockEnd: "0",
  backgroundColor: "fill-surface-default",
  borderBlockStartStyle: "solid",
  borderBlockStartWidth: "200",
  borderBlockStartColor: "temp-do-not-use-border-primary-disabled",
  children: children
});
const CalleeSelectDropdownWrapper = ({
  children
}) => /*#__PURE__*/_jsx(Flex, {
  maxBlockSize: "400px",
  overflow: "auto",
  flexDirection: "column",
  children: children
});
export const ThirdPartySettingsNumbersHelpDesk = props => {
  const {
    appIdentifier,
    calleesData,
    isKnownVisitor,
    visitorPhoneNumber,
    startOutboundCall,
    selectedCallProvider,
    onCallButtonClick,
    gates
  } = props;
  const isUngatedForProviderSwitching = useMemo(() => {
    return isProviderSwitchingEnabled(gates);
  }, [gates]);
  return /*#__PURE__*/_jsxs(CalleeSelectDropdownWrapper, {
    children: [/*#__PURE__*/_jsx(SearchableCalleeList, {
      appIdentifier: appIdentifier,
      calleesData: calleesData || null,
      onSelectToNumber: startOutboundCall,
      disabled: false,
      canEdit: false,
      showAddPropertyButton: false,
      disabledTooltipMessage: null,
      isKnownVisitor: isKnownVisitor,
      visitorPhoneNumber: visitorPhoneNumber
    }), !isUngatedForProviderSwitching && /*#__PURE__*/_jsx(CallNotesButtonWrapper, {
      children: /*#__PURE__*/_jsx(CurrentSettingsInfoHelpDesk, {
        disabled: false,
        selectedCallProvider: selectedCallProvider,
        onCallButtonClick: onCallButtonClick
      })
    })]
  });
};